import { ServiceData } from '@/types';

import audios from './MEDITATION_AUDIOS_LV.json';
import guides from './MEDITATION_GUIDES_LV.json';

export const MEDITATION_DATA_LV: ServiceData = {
  audios,
  guides,
};
